module.exports = __webpack_public_path__ + "static/media/Earned.257e806e.gif";